import { render, staticRenderFns } from "./pt-sp-edit.vue?vue&type=template&id=50c3828b&"
import script from "./pt-sp-edit.vue?vue&type=script&lang=js&"
export * from "./pt-sp-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports